<div class="detail-section">
    <section class="rule-info-section">
        <div class="content">
            <span class="label">
                Nombre
            </span>
            <span class="value">{{minuteRequestApprovalRuleDetail.name}}</span>
        </div>
        <div class="content">
            <span class="label">
                Descripción
            </span>
            <span class="value">{{minuteRequestApprovalRuleDetail.description || 'Sin descripción'}}</span>
        </div>
    </section>
    <section class="rule-info-section">
        <div class="content">
            <span class="label">
                Firmas requeridas
            </span>
            <span class="value">{{minuteRequestApprovalRuleDetail.minApprovalRequired}}</span>
        </div>
        <div class="content">
            <span class="label">
                Prioridad
            </span>
            <span class="value">{{minuteRequestApprovalRuleDetail.priority}}</span>
        </div>
    </section>
    <section class="rule-info-section">
        <div class="content">
            <span class="label">Roles</span>
            <mat-chip-set aria-label="Roles">
                @for(role of minuteRequestApprovalRuleDetail.roles; track role){
                    <mat-chip disableRipple="true" color="primary">
                        <span class="value">{{role.name}}</span>
                    </mat-chip>
                }
            </mat-chip-set>
        </div>
    </section>
        <div class="condition-header">
            <h3>Condiciones</h3>
            <button [disabled]="!canUpdateApprovalRule" mat-icon-button (click)="clickNewMinuteApprovalConditions()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <mat-card class="cardWithShadow">
            <section [hidden]="conditionsDataSource.data.length == 0">
                <table mat-table [dataSource]="conditionsDataSource">
                    <ng-container matColumnDef="parameterName">
                        <th mat-header-cell *matHeaderCellDef>
                            Parametro
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.minuteApprovalParameterName}}
                        </td>
                    </ng-container>
        
                    <ng-container matColumnDef="comparator">
                        <th mat-header-cell *matHeaderCellDef>
                            Comparador
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{labelComparators.get(element.comparator)}}
                        </td>
                    </ng-container>
        
                    <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef>
                            Valor
                        </th>
                        <td mat-cell *matCellDef="let element">
                            @if(element.contextualValue) {
                                {{element.contextualValue}}
                            }@else {
                                {{ element.value | number}}
                            }
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="conditionTableCols"></tr>
                    <tr class="condition-row" mat-row *matRowDef="let row; columns: conditionTableCols" [cdkContextMenuTriggerFor]="contextmenu">
                        <!-- Menu contextual de condiciones de regla -->
                        <ng-template #contextmenu>
                            <div class="context-menu-condition" cdkMenu>
                                <button [disabled]="!canUpdateApprovalRule" mat-raised-button cdkMenuItem (click)="clickUpdateCondition(row)" >
                                    Modificar
                                </button>
                                <button [disabled]="!canUpdateApprovalRule" mat-raised-button cdkMenuItem (click)="clickRemoveCondition(row.minuteRequestApprovalRuleConditionId)">
                                    Quitar
                                </button>
                            </div>
                        </ng-template>
                    </tr>
                </table>
                <mat-paginator #conditionPaginator [pageSizeOptions]="[10, 20, 30]"></mat-paginator>                
            </section>
            <span *ngIf="conditionsDataSource.data.length == 0" class="span-centered">Sin condiciones</span>
        </mat-card>
    <!-- <section class="approval-info">
        <span>{{minuteRequestApprovalRuleDetail.name}}</span>
    </section> -->
</div>